import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'craig-response-loader',
    templateUrl: './response-loader.component.html',
    styleUrl: './response-loader.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResponseLoaderComponent {
    loaderMessage: string = 'One moment please, CRAiG is thinking';
}
